<template>
    <div class="product-page">
        <img src="@/assets/startImg.png" alt="首页" class="imgDiv">
        <img src="@/assets/tableImg.png" alt="导航" class="imgDiv">
        <img src="@/assets/solar_controller_Img.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_1.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_2.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_3.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_4.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_5.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_6.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_7.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_8.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_9.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_10.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/solar_controller_11.png" alt="太阳能控制器" class="imgDiv">
        <img src="@/assets/inverterImg.png" alt="逆变器" class="imgDiv">
        <img src="@/assets/inverter_1.png" alt="逆变器" class="imgDiv">
        <img src="@/assets/inverter_2.png" alt="逆变器" class="imgDiv">
        <img src="@/assets/hydro_generatorImg.png" alt="水力发电机" class="imgDiv">
        <img src="@/assets/hydro_generator_1.png" alt="水力发电机" class="imgDiv">
        <img src="@/assets/hydro_generator_2.png" alt="水力发电机" class="imgDiv">
        <img src="@/assets/solar_inverterImg.png" alt="太阳能逆控一体机" class="imgDiv">
        <img src="@/assets/solar_inverter_1.png" alt="太阳能逆控一体机" class="imgDiv">
        <img src="@/assets/solar_inverter_2.png" alt="太阳能逆控一体机" class="imgDiv">
        <img src="@/assets/digital_power_meterImg.png" alt="数字功率计" class="imgDiv">
        <img src="@/assets/digital_power_meter_1.png" alt="数字功率计" class="imgDiv">
        <img src="@/assets/flashlightImg.png" alt="储能手电筒" class="imgDiv">
        <img src="@/assets/flashlight_1.png" alt="储能手电筒" class="imgDiv">
        <img src="@/assets/routerImg.png" alt="WIFI发射器" class="imgDiv">
        <img src="@/assets/router_1.png" alt="WIFI发射器" class="imgDiv">
        <img src="@/assets/router_2.png" alt="WIFI发射器" class="imgDiv">
        <img src="@/assets/endImg.png" alt="结束" class="imgDiv">

    </div>
</template>

<script>
export default {
    name: 'ProductPage'
}
</script>

<style scoped>
/* 全局样式重置与基础设置 */
.product-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.imgDiv {
    display: block;
    width: 100%;
    height: auto;
    max-height: 65rem;
    margin: 1rem auto;
    object-fit: contain;
}

/* 移动端适配：屏幕宽度小于768px时 */
@media (max-width: 767px) {
    .imgDiv {
        max-height: 30rem;
        margin: 0.75rem auto;
    }
}

/* 平板端适配：屏幕宽度在768px-1023px之间 */
@media (min-width: 768px) and (max-width: 1023px) {
    .imgDiv {
        max-height: 45rem;
        margin: 0.875rem auto;
    }
}
</style>